<template>
  <div>
    <PageHeader />
    <ProjInfo :projectInfo="projectInfo" :changelog="changelog" />


    <v-container class="section-block">
        <v-row>
            <v-col class="col-12 col-md-4">
                <h3>Workflow</h3>
                <ol>
                    <li>Select keyframes</li>
                    <li>Click the button</li>
                    <li>Selected keyframe values will be rounded to the nearest whole number</li>
                </ol>
                <h3>Note</h3>
                <p>Trim path keyframes toward the end of the range will be ignored. This is to avoid the annoying disappear/reappear that happens with round-cap strokes.</p>
            </v-col>
            <v-col class="col-12 col-md-4">
                <img :src="images.ui" width="100%" alt="">
            </v-col>
        </v-row>
    
    </v-container>
    <InstallInfo id="install" name="Flattop" scriptUI :hosts="['After Effects']"/>

    <Changelog :changelog="changelog" /> 
    
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'conclave',
  components: {
  },
  data: () => ({
      images: {
            ui: require('../assets/images/Flattop.jpg'),
        },
        video: {
            updateKeyframes: require('../assets/video/Dotkit-UpdateKeys.mp4'),
        },
      projectInfo: {
          name: 'Flattop',
          subtitle: 'Remove those pesky decimal points from keyframes',
          source: true,
          about: `Keyframes are just a bunch of numbers, but you don't always want a bunch decimal places –especially on position values. So round them to whole numbers quickly. `,
      },
      changelog: [
            {
                version: '0.1.4',
                date: 'Oct 27, 2021',
                fixed: [
                    'Line 91 - keys.forEach is undefined',
                ],
            },
            {
                version: '0.1.3',
                date: 'Mar 26, 2021',
                fixed: [
                    'Stroke Width properties will not round down to 0 to avoid them popping off screen',
                ],
            },
            {
                version: '0.1.2',
                date: 'Feb 9, 2021',
                added: [
                    'May be launched as a headless script from KBar with the argument: run',
                ],
            },
            {
                version: '0.1.1',
                date: 'Jan 29, 2021',
                comment: ['Initial release'],
            },
        ]
  }),
}
</script>